import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-file-multiple-upload',
  templateUrl: './file-multiple-upload.component.html',
  styleUrls: ['./file-multiple-upload.component.scss'],
})
export class FileMultipleUploadComponent {
  @Input() acceptedFileTypes: string = '';
  @Input() showUploadProgress: boolean = false;
  @Input() uploadProgress: number = 0;
  @Input() maxFileSize: number = 25 * 1024 * 1024; // 25MB by default
  @Input() selectedFile: any = {};

  @Output() filesUploaded = new EventEmitter<File>();
  @Output() fileSelected = new EventEmitter<File[]>();
  @Output() fileRemoved = new EventEmitter();

  files: File[] = [];

  dragOver: boolean = false;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    if (this.selectedFile) {
      this.files = this.selectedFile;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedFile'] && changes['selectedFile'].currentValue) {
      const file = changes['selectedFile'].currentValue;
      this.files = file;
      this.fileSelected.emit(file);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      this.handleFiles(fileArray);
    }
  }

  onFileSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;

    if (files && files.length > 0) {
      this.files = Array.from(files);
      this.fileSelected.emit(Array.from(files));
    }
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
      this.handleFiles(files);
    }
  }

  handleFiles(files: File[]): void {
    const validFiles: File[] = [];

    files.forEach((file) => {
      if (file.size > this.maxFileSize) {
        const maxSize = this.maxFileSize / 1024 / 1024;
        this.toastService.showError(
          `O arquivo ${file.name} excede o limite de tamanho de ${maxSize}MB.`,
        );
      } else {
        this.files.push(file);
        validFiles.push(file);
      }
    });

    if (validFiles.length > 0) {
      this.fileSelected.emit(validFiles);
    }
  }

  removeFile(file: any) {
    const index = this.files.findIndex(
      (f) =>
        f.name === file.name && f.size === file.size && f.type === file.type,
    );

    if (index !== -1) {
      this.files.splice(index, 1);
      this.fileRemoved.emit(this.files); // Você pode emitir o próprio arquivo removido, se quiser
    }
  }
}
